export const getDaysInMilliseconds = (days) => days * 24 * 60 * 60 * 1000;
